import { call, put, select } from 'redux-saga/effects'
import { getData as apiGetData } from 'api/Api'
import {
  setLoadStatus,
  setStart,
  setEnd,
  addItemArray,
  clearItems
} from '../redux/calendar'
import * as CalendarItemTypes from 'const/CalendarItemTypes'

export default function * fetchCalendarItems (action) {
  const { start, end } = action.payload
  
  const state = yield select()
  const vBoardId = state['view-myboard'].view.id
  
  yield put([
    clearItems(),
    setStart(start),
    setEnd(end),
    setLoadStatus({
      isLoading: true,
      isLoaded: false
    })
  ])

  try {
    const { Items } = yield call(apiGetData, 'CalendarItems', {
      vBoardId: vBoardId,
      from: start,
      to: end
    })

    yield put([
      addItemArray(Items.filter(Item => Item.StartDate || Item.DueDate).map(Item => ({
        id: Item.Id,
        cardId: Item.CardId,
        type: CalendarItemTypes.OUTLOOK,
        name: Item.Name,
        startDate: Item.StartDate,
        dueDate: Item.DueDate
      }))),
      setLoadStatus({
        isLoading: false,
        isLoaded: true
      })
    ])
  } catch (error) {
    if (error.code === 9000) {
      yield put(setLoadStatus({
        isLoading: false,
        isLoaded: false
      }))
    } else {
      throw error
    }
  }
}
